// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titleInfo[data-v-4a02758d]{text-decoration:underline;font-weight:700;font-size:14px}", ""]);
// Exports
module.exports = exports;
